export default __webpack_public_path__ + "static/media/pc_a_color.c301548c.svg";